import { Navigate, createBrowserRouter } from 'react-router-dom';
import { AuthCallback } from '@/auth/AuthCallback';
import { ForbiddenPage } from '@/auth/ForbiddenPage';
import { LoginPage } from '@/auth/LoginPage';
import { LoggedOutPage } from '@/auth/LoggedOutPage';
import { RequireBackofficeAuth } from '@/auth/RequireBackofficeAuth';
import { BackofficeHomePage } from '@/views/home/BackofficeHomePage';
import { BackofficeDashboardPage } from '@/views/dashboard/BackofficeDashboardPage';
import { BackofficeDeveloperPage } from '@/views/developer/BackofficeDeveloperPage';
import { BackofficeInterviewDetailsPage } from '@/views/interviews/BackofficeInterviewDetailsPage';
import { BackofficeInterviewsPage } from '@/views/interviews/BackofficeInterviewsPage';
import { BackofficeLinkDetailsPage } from '@/views/links/BackofficeLinkDetailsPage';
import { BackofficeLinksPage } from '@/views/links/BackofficeLinksPage';
import { BackofficeOrganizationDetailsPage } from '@/views/organizations/BackofficeOrganizationDetailsPage';
import { BackofficeOrganizationsPage } from '@/views/organizations/BackofficeOrganizationsPage';
import { BackofficeProjectDetailsPage } from '@/views/projects/BackofficeProjectDetailsPage';
import { BackofficeProjectInterviewsPage } from '@/views/projects/BackofficeProjectInterviewsPage';
import { BackofficeProjectsPage } from '@/views/projects/BackofficeProjectsPage';
import { BackofficeSettingsPage } from '@/views/settings/BackofficeSettingsPage';
import { BackofficeMessageBusPage } from '@/views/messagebus/BackofficeMessageBusPage';
import { BackofficeMessageBusSubscriberPage } from '@/views/messagebus/BackofficeMessageBusSubscriberPage';
import { BackofficeMessageBusTopicPage } from '@/views/messagebus/BackofficeMessageBusTopicPage';
import { BackofficeUserDetailsPage } from '@/views/users/BackofficeUserDetailsPage';
import { BackofficeUsersPage } from '@/views/users/BackofficeUsersPage';
import { BackofficeVoucherDetailsPage } from '@/views/vouchers/BackofficeVoucherDetailsPage';
import { BackofficeSearchResultsPage } from '@/views/search/BackofficeSearchResultsPage';
import { BackofficeVouchersPage } from '@/views/vouchers/BackofficeVouchersPage';
import { BackofficeTagsPage } from '@/views/tags/BackofficeTagsPage';
import { BackofficeObservabilityPage } from '@/views/observability/BackofficeObservabilityPage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/callback',
    element: <AuthCallback />,
  },
  {
    path: '/logout',
    element: <LoggedOutPage />,
  },
  {
    path: '/',
    element: (
      <RequireBackofficeAuth>
        <BackofficeHomePage />
      </RequireBackofficeAuth>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <BackofficeDashboardPage />,
      },
      {
        path: 'developer',
        element: <BackofficeDeveloperPage />,
      },
      {
        path: 'developer/messagebus',
        element: <BackofficeMessageBusPage />,
      },
      { path: 'developer/observability', element: <BackofficeObservabilityPage /> },
      {
        path: 'developer/messagebus/topics/:topicName',
        element: <BackofficeMessageBusTopicPage />,
      },
      {
        path: 'developer/messagebus/topics/:topicName/subscribers/:subscriberName',
        element: <BackofficeMessageBusSubscriberPage />,
      },
      {
        path: 'links',
        element: <BackofficeLinksPage />,
      },
      {
        path: 'links/:slug',
        element: <BackofficeLinkDetailsPage />,
      },
      {
        path: 'error/403',
        element: <ForbiddenPage />,
      },
      {
        path: 'projects',
        element: <BackofficeProjectsPage />,
      },
      {
        path: 'projects/:projectId',
        element: <BackofficeProjectDetailsPage />,
      },
      {
        path: 'projects/:projectId/interviews',
        element: <BackofficeProjectInterviewsPage />,
      },
      {
        path: 'organizations',
        element: <BackofficeOrganizationsPage />,
      },
      {
        path: 'organizations/:organizationId',
        element: <BackofficeOrganizationDetailsPage />,
      },
      {
        path: 'interviews',
        element: <BackofficeInterviewsPage />,
      },
      {
        path: 'interviews/:interviewId',
        element: <BackofficeInterviewDetailsPage />,
      },
      {
        path: 'users',
        element: <BackofficeUsersPage />,
      },
      {
        path: 'users/:userId',
        element: <BackofficeUserDetailsPage />,
      },
      {
        path: 'vouchers',
        element: <BackofficeVouchersPage />,
      },
      {
        path: 'vouchers/:voucherId',
        element: <BackofficeVoucherDetailsPage />,
      },
      { path: 'tags', element: <BackofficeTagsPage /> },
      {
        path: 'search',
        element: <BackofficeSearchResultsPage />,
      },
      {
        path: 'settings',
        element: <BackofficeSettingsPage />,
      },
    ],
  },
]);
